import React from "react"
import Slider, { SliderProps } from "@mui/material/Slider"
import { styled } from "@mui/material/styles"

import { colors } from "theme"

const SliderComponent = styled((props: SliderProps) => <Slider {...props} />)(
  () => ({
    color: colors.persianGreen,
    height: 2,
    "& .MuiSlider-rail": {
      border: "none",
      backgroundColor: colors.antiFlashWhite,
    },
    "& .MuiSlider-track": {
      border: "none",
      backgroundColor: colors.antiFlashWhite,
    },
    "& .MuiFilledInput-root": {},
  }),
)

export default SliderComponent
